import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

export const initSentry = () => {
  if (!import.meta.env.VITE_SENTRY_FRONTEND_DSN) {
    console.warn('Sentry DSN not found');
    return;
  }

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_FRONTEND_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.globalHandlersIntegration({ onerror: true, onunhandledrejection: true }),
      Sentry.httpClientIntegration(),
      Sentry.httpContextIntegration(),
      Sentry.extraErrorDataIntegration(),
    ],
    sendDefaultPii: true,
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Enable source maps
    enabled: true,
    release: import.meta.env.VITE_SENTRY_RELEASE || '1.0.0',
    environment: import.meta.env.MODE,
    tracePropagationTargets: ['https://hopkinsai.vercel.app', 'hopkinsai.vercel.app'],
  });
};

export const setUserContext = (user: { id: string; email?: string } | null, jwt?: string) => {
  if (user) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      jwt: jwt, // Adding JWT for debugging (Note: consider security implications)
    });
  } else {
    Sentry.setUser(null);
  }
};
